import React from 'react';
import { HeroSection } from './HeroSection';
import { ProblemSection } from './ProblemSection';
import { SolutionSection } from './SolutionSection';
import { BonusSection } from './BonusSection';
import { BeforeAfterSection } from './BeforeAfterSection';
import { TestimonialsSection } from './TestimonialsSection';
import { PricingSection } from './PricingSection';
import { FooterSection } from './FooterSection';
export function SalesPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-136">
      <HeroSection data-id="element-137" />
      <ProblemSection data-id="element-138" />
      <SolutionSection data-id="element-139" />
      <BonusSection data-id="element-140" />
      <BeforeAfterSection data-id="element-141" />
      <TestimonialsSection data-id="element-142" />
      <PricingSection data-id="element-143" />
      <FooterSection data-id="element-144" />
    </div>;
}